module.exports = __webpack_public_path__ + "img/corpnetwork.a3b79f52.png";